import React from "react";
import { Controller } from "react-hook-form";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Tooltip from "@mui/material/Tooltip";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { ComponentAuthorisation } from "../ComponentAuthorisation";

export const QuantityControl = React.memo(function QuantityControl({
  control,
  fieldName,
  validSKU,
  decrementQuantity,
  incrementQuantity,
  autofillEntitlement,
  validationHelper,
}) {
  return (
    <Controller
      name={fieldName}
      control={control}
      defaultValue={0}
      rules={{ required: true, min: 0 }}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          disabled={!validSKU()}
          error={!!error}
          sx={{ width: "100%" }}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{
              alignItems: "center",
            }}
          >
            <ComponentAuthorisation
              allowedRoles={["allowentitlement", "staffRequestCreate"]}
            >
              <Tooltip title="Autofill entitlement">
                <span>
                  <IconButton
                    size="small"
                    color="secondary"
                    onClick={autofillEntitlement}
                    disabled={!validSKU()}
                  >
                    <AutoAwesomeIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            </ComponentAuthorisation>
            <Paper
              variant="outlined"
              sx={{
                px: 0.5,
                display: "flex",
                alignItems: "center",
                width: "100%",
                borderColor: validSKU() ? "info.main" : "grey.300",
                height: 36,
              }}
            >
              <IconButton
                size="small"
                color="info"
                onClick={decrementQuantity}
                disabled={!validSKU()}
              >
                <RemoveIcon fontSize="inherit" />
              </IconButton>
              <InputBase
                {...field}
                type="number"
                disabled={!validSKU()}
                slotProps={{
                  htmlInput: {
                    min: 0,
                    style: { textAlign: "center" },
                  },
                }}
                sx={{
                  flexGrow: 1,
                  fontVariantNumeric: "tabular-nums",
                  "& input": { textAlign: "center" },
                }}
              />
              <IconButton
                size="small"
                color="info"
                onClick={incrementQuantity}
                disabled={!validSKU()}
              >
                <AddIcon fontSize="inherit" />
              </IconButton>
            </Paper>
          </Stack>
          {error && (
            <FormHelperText>
              {validationHelper.quantity[error.type]}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
});

export default QuantityControl;
